import React, {Component} from 'react'
import {injectIntl, FormattedMessage} from 'react-intl'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {Button, Modal, Table, Icon, Popconfirm, Tag} from 'antd'
import {getClients, getTypeClients, getWorkClients, getTypeBusinessClients} from '../../actions/ClientsAction'
import {existsConfirmAssets} from '../../actions/AssetsConfirmAction'
import {
  getClientById,
  getBreadCrumbsByClient,
  getUserClientRole,
  setPidExistsConfirmAssets,
  deleteClient
} from '../../actions/ClientAction'
import {sendNotification, getWithDrawer, PROD_CLIENT_IAB_COLOMBIA} from '../../utils'
import CreateClient from '../create-client/createClient'
import BunkeyApi from '../../api/BunkeyAPI'
import EditClient from '../create-client/EditClient'
import './client.css'
import ListSearcher from '../searcher/ListSearcher'
import { getDefaultPermissions } from '../../actions/GroupAction'

const ImageCell = image => (<img style={{width: 50}} src={image.image} alt="logo"/>)

const ButtonGroup = Button.Group

export class ListCliente extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: null,
      limit: 10,
      count: 1,
      activePage: 1,
      showCreateClient: false,
      showEditClient: false,
      editData: null,
      userSelected: null,
      fNameOrEmail: ''
    }
    const {intl, user} = this.props

    this.columns = [
      {
        title: 'Logo',
        dataIndex: 'logo',
        render: image => <ImageCell image={image}/>,
      }, {
        title: <FormattedMessage id="clients_dni"/>,
        dataIndex: 'dni',
        sorter: (a, b) =>
          a.dni < b.dni
            ? -1
            : a.dni > b.dni
            ? 1
            : 0,
      }, {
        title: <FormattedMessage id="business_name"/>,
        dataIndex: 'companyName',
        sorter: (a, b) =>
          a.companyName < b.companyName
            ? -1
            : a.companyName > b.companyName
            ? 1
            : 0,
      }, {
        title: <FormattedMessage id="contact"/>,
        dataIndex: 'agent',
      }, {
        title: <FormattedMessage id="modules"/>,
        dataIndex: 'modules',
        render: row => {
          const mod = row.map((m, k) => {
            if (m.activate === true) {
              return <div key={k} style={{display: 'flex'}}><span
                style={{marginRight: 5}}>{m.name}</span><Tag
                color="green"> {intl.formatMessage({id: 'activated'})}</Tag></div>
            } else {
              return <div key={k} style={{display: 'flex'}}><span
                style={{marginRight: 5}}>{m.name}</span><Tag
                color="red"> {intl.formatMessage({id: 'deactivated'})}</Tag></div>
            }
          })
          return (
            mod.map((r, k) => r)
          )
        }
      },
      // {
      //   title: <FormattedMessage id="clients_ContactData" />,
      //   dataIndex: 'email',
      // },
      {
        title: intl.formatMessage({id: "action"}),
        dataIndex: 'action',
        render: row => {
          return (
            <ButtonGroup>
              <Button type="default" onClick={this.handleEditUser}><Icon type="edit"/></Button>
              <Popconfirm placement="topLeft" title={intl.formatMessage({id: "delete_client_question"})}
                          onConfirm={this.handleDeleteClient} okText={intl.formatMessage({id: 'yes'})} cancelText="No">
                <Button type="default"><Icon type="delete"/></Button>
              </Popconfirm>
              {user.email === 'jorge@bunkey.tv' &&
              <Popconfirm placement="topLeft" title={intl.formatMessage({id: "client_convertion_confirm"})}
                          onConfirm={this.handleSendConvertionClient} okText={intl.formatMessage({id: 'yes'})}
                          cancelText="No">
                <Button type="default"><Icon type="rocket"/></Button>
              </Popconfirm>}
            </ButtonGroup>
          )
        }
      }]
  }

  componentDidMount() {
    this.props.getTypeClients()
    this.props.getTypeBusinessClients()
    this.handleGetData()
    this.showCreateFromDashboard()
    this.showEditFromDashboard()
  }

  componentDidUpdate(prevProps) {
    const {data, headers, isFetching, error, intl, statusDelete} = this.props

    if (!isFetching && error && prevProps.error !== error) {
      this.setState({
        data: null
      }, () => {
        sendNotification('error', intl, intl.formatMessage({id: 'error_message'}))
      })
    } else if (!isFetching
      && data
      && data.length > 0
      && prevProps.data !== data) {

      this.setState({
        data,
        limit: parseInt(headers['x-pagination-limit']),
        count: parseInt(headers['x-pagination-total-count']),
      })
    }
    if (prevProps.statusDelete !== statusDelete) {
      if (statusDelete === 'success') {
        sendNotification('success', intl, intl.formatMessage({id: "delete_client_success"}))
      } else if (statusDelete === 'failed') {
        sendNotification('success', intl, intl.formatMessage({id: "delete_client_error"}))
      }
    }
  }

  handleGetData = () => {
    const {activePage} = this.state
    const {user} = this.props

    if (user.role === 'admin') {
      this.props.getClients(activePage)
    } else {
      if (user.workClients.length === 1) {
        this.handleSetWorkClient(user.workClients[0])
      } else {
        this.props.getWorkClients(user.workClients)
      }
    }
  }

  handleSetWorkClient = id => {
    // const { intl } = this.props 

    this.setState({
      isLoading: true
    }, () => {
      // 20201007 IAB COLOMBIA
      // SI ES IAB COLOMBIA SE ASIGNA COLOR FIJO
      if (id === PROD_CLIENT_IAB_COLOMBIA) {
        this.props.forceColor('#C62918')
      }

      this.props.getClientById(id)
        .then(() => {
          this.props.getDefaultPermissions()
          return this.props.getUserClientRole(id)
        }).then(() => {
          this.props.getBreadCrumbsByClient(id)
        }).catch(err => {

        })
    })
  }

  handleGetBreadCrumbs = workclient => {
    this.props.getBreadCrumbsByClient(workclient)
    setTimeout(() => {
      this.props.history.push('/home')
    }, 500)
  }

  onChangePage = page => {
    this.setState({
      activePage: page,
    }, () => {
      this.handleGetData()
    })
  }

  handleShowCreateClient = () => {
    this.setState({showCreateClient: true})
  }

  handleHideCreateClient = () => {
    this.setState({showCreateClient: false})
  }

  handleEditUser = () => {
    const {userSelected} = this.state

    this.setState({
      showEditClient: true,
      editData: userSelected
    })
  }

  handleHideEditClient = () => {
    this.setState({showEditClient: false})
  }

  handleDeleteClient = () => {
    const {activePage, userSelected} = this.state

    this.props.deleteClient(userSelected._id)
    setTimeout(() => {
      this.props.getClients(activePage)
    }, 1000)
  }

  handleSetUser = key => {
    this.setState({
      userSelected: key
    })
  }

  handleSendConvertionClient = () => {
    const {userSelected} = this.state
    const {intl} = this.props
    BunkeyApi({
      url: `/convertinators/client`,
      method: 'POST',
      data: {
        clientId: userSelected._id
      }
    }).then(resp => {
      if (resp.status === 201) {
        sendNotification('success', intl, intl.formatMessage({id: 'convetinator_force_conversion_success'}))
      } else {
        sendNotification('error', intl, intl.formatMessage({id: 'error_message'}))
      }
    }).catch(err => {
      sendNotification('error', intl, intl.formatMessage({id: 'error_message'}))
    })
  }

  filterByName = (e) => {
    const {value} = e.target
    this.setState({fNameOrEmail: value ? value.toString().trim() : ''})
  }

  handleOnSearch = () => {
    this.setState({fNameOrEmail: ''})
  }

  handleOnchageSearch = e => {
    this.setState({fNameOrEmail: e.target.value})
  }

  showCreateFromDashboard(){
    if( !this.props.location.state || 
        this.props.location.state === undefined){
       this.setState({
          showCreateClient: false
       })
    }else{
      this.setState({ showCreateClient: true, showEditClient: false})
    }
  }

  showEditFromDashboard(){
    if( !this.props.location.state || 
        this.props.location.state === undefined ||
        !this.props.location.state.editData){
       this.setState({
          showEditClient: false
       })
    }else{
      let{ editData } = this.props.location.state
      editData['companyName'] = editData['client']
      this.setState({ showEditClient: true, editData: editData, showCreateClient: false })
    }
  }

  render() {
    const {data, limit, count, activePage, showCreateClient, showEditClient, editData, fNameOrEmail} = this.state
    const {width, isFetching, newColor, intl, workclient} = this.props
    const isMobileTable = width
      ? width <= 768
        ? true
        : false
      : false
    let dataTable = null

    //Funcion para quitar las tildes de un texto
    const removeAccents = (text) => {
      return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
    if (data && data.length > 0) {
      dataTable = (data && data.length > 0)
        ? data.map(r => {          
          //Validamos si tiene modulos y si no lo añadimos como false
          const isMFA = r.modules.find((m) => m.name === 'MFA')
          const isCommentsAndVersions = r.modules.find(
            (m) => m.name === 'commentsAndVersions'
          )
          const BunkeyHost = r.modules.find(
            (m) => m.name === 'BunkeyHost'
          )
          const isGroupSystem = r.modules.find(
            (m) => m.name === 'sistemasDeGrupos'
          )
          let newModules = [...r.modules]
          if (!isMFA)
            newModules = [...newModules, {name: 'MFA', activate: false}]
          if (!isCommentsAndVersions)
            newModules = [
              ...newModules,
              {name: 'commentsAndVersions', activate: false},
            ]
          if (!isGroupSystem)
            newModules = [
              ...newModules,              
              {name: 'sistemasDeGrupos', activate: false},
            ]
          if (!BunkeyHost)
            newModules = [...newModules, {name: 'BunkeyHost', activate: false}]

          return {
            logo: r.acountSetting.logo,
            dni: r.dni,
            companyName: r.name,
            agent: r.agent,
            phone: r.phone,
            email: r.email,
            clientType: r.clientType, 
            businessType: r.businessType,
            editable: r.editable,
            modules: newModules,
            dartCustomField: r.dartCustomField,
            contractedUsers: r.contractedUsers,
            contractedSpace: r.contractedSpace,
            _id: r._id,
            media: r.media,
            statusAsset: r.statusAsset,
          }
        })
        : null

      dataTable = dataTable
        ? dataTable
          .map((d) => {
            const rgx = new RegExp(removeAccents(fNameOrEmail).replace(/[^a-zA-Z0-9]/g, ''), 'gi')

            if (
              fNameOrEmail !== '' &&
              !rgx.test(removeAccents(d.companyName))
            )
              return null
            else return d
          })
          .filter((d) => d)
        : []
    }


    return (
      <React.Fragment>
        <div className="title-bar">
          <div className="container" style={{borderLeftColor: newColor}}>
            <span>{intl.formatMessage({id: 'clients_client_List'})}</span>
            <div
              style={{
                display: 'block',
                float: 'right',
                marginRight: 10,
                marginTop: 10
              }}>
              <button
                className="ant-btn ant-btn-primary"
                style={{backgroundColor: newColor, borderColor: newColor}}
                onClick={this.handleShowCreateClient}
              >{intl.formatMessage({id: 'create_client'})}</button>
            </div>
          </div>

        </div>


        <div className="assets-wrapper">
          <div className="container">
            <ListSearcher
              client={workclient}
              placeholder={intl.formatMessage({id: 'enter_text_to_search_for_client'})}
              loading={isFetching}
              searchButtonText={intl.formatMessage({id: 'all'})}
              filterByNameOrEmail={this.filterByNameOrEmail}
              handleOnSearch={this.handleOnSearch}
              fNameOrEmail={fNameOrEmail}
              handleOnchageSearch={this.handleOnchageSearch}
            />
          </div>
        </div>


        <div className="assets-wrapper">
          <div className="container">
            {!isMobileTable && <Table
              bordered
              loading={isFetching}
              // className="selector-client-table"
              columns={this.columns}
              rowKey='_id'
              onRow={row => ({
                onMouseEnter: () => {
                  document.body.style.cursor = "pointer"
                  this.handleSetUser(row)
                },
                onMouseLeave: () => {
                  document.body.style.cursor = "default"
                }
              })}
              dataSource={dataTable}
              pagination={{
                current: activePage,
                pageSize: limit,
                total: count,
                onChange: this.onChangePage
              }}/>}
            {isMobileTable && <Table
              bordered
              loading={isFetching}
              className='selector-client-responsive'
              columns={this.columns.filter(r => ['companyName', 'email', 'action'].includes(r.dataIndex))}
              rowKey='_id'
              onRow={row => ({
                onMouseEnter: () => {
                  document.body.style.cursor = "pointer"
                  this.handleSetUser(row)
                },
                onMouseLeave: () => {
                  document.body.style.cursor = "default"
                }
              })}
              dataSource={dataTable}
              pagination={{
                current: activePage,
                pageSize: limit,
                total: count,
                onChange: this.onChangePage
              }}/>}
          </div>
        </div>
        <Modal
          title={intl.formatMessage({id: 'create_client'})}
          width={getWithDrawer()}
          closable={true}
          destroyOnClose={true}
          footer={null}
          onCancel={this.handleHideCreateClient}
          onClose={this.handleHideCreateClient}
          visible={showCreateClient}
          keyboard={true}>
          <CreateClient
            handleHideCreateClient={this.handleHideCreateClient}
            activePage={activePage}/>
        </Modal>
        <Modal
          title={intl.formatMessage({id: 'edit_client'})}
          width={getWithDrawer()}
          closable={true}
          destroyOnClose={true}
          onCancel={this.handleHideEditClient}
          onClose={this.handleHideEditClient}
          visible={showEditClient}
          footer={null}
          keyboard={true}>
          <EditClient
            editData={editData}
            activePage={activePage}
            handleHideEditClient={this.handleHideEditClient}/>
        </Modal>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
  width: state.app.width,
  user: state.authUser.user,
  data: state.clients.data,
  headers: state.clients.headers,
  isFetching: state.clients.isFetching,
  error: state.clients.error,
  statusDelete: state.client.statusDelete
})

const mapDispatchToProps = {
  getClients,
  getWorkClients,
  getClientById,
  getBreadCrumbsByClient,
  getUserClientRole,
  setPidExistsConfirmAssets,
  existsConfirmAssets,
  deleteClient,
  getDefaultPermissions,
  getTypeClients,
  getTypeBusinessClients
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ListCliente)))
